import { apiFetch } from '../helpers/api-fetch';
import { TokenRequest } from '../models/token-request';
import { TokenUser } from '../models/token-user';
import decode from 'jwt-decode';
import { Role } from '../helpers/role';
import { BehaviorSubject } from 'rxjs';

export class AuthService {

    static readonly APIUrl = process.env.REACT_APP_API_URL as string; // API server domain
    static readonly TokenName = process.env.REACT_APP_TOKEN_NAME as string; // Token key name for local storage

    // Subject that requires an initial value and emits its current value to new subscribers
    static readonly currentUserSubject = new BehaviorSubject(AuthService.decodeToken());

    // Get a token from api server using the fetch api
    public static login(username: string, password: string) {
        console.log(AuthService.APIUrl);
        var request = new TokenRequest(username, password);

        return apiFetch(`${AuthService.APIUrl}/api/auth/token`, {
            method: 'POST',
            body: JSON.stringify(request)
        }).then(res => {
            AuthService.setToken(res.token) // Setting the token in localStorage
            return Promise.resolve(res);
        });
    }

    // Clear user token and profile data from localStorage
    public static logout() {
        localStorage.removeItem(AuthService.TokenName);
        AuthService.currentUserSubject.next(undefined);
    }

    // Checks if there is a saved token and it's still valid and returns current User profile
    public static getProfile(): TokenUser | null | undefined {
        let tokenUser: TokenUser | null | undefined;
        tokenUser = AuthService.currentUserSubject.value;

        if (!!tokenUser && !AuthService.isTokenExpired(tokenUser)) {
            return tokenUser;
        }
    }

    public static loggedIn() {
        return !!this.getProfile();
    }

    public static isAdmin() {
        let tokenUser = this.getProfile();
        if (tokenUser && tokenUser.roles && tokenUser.roles.some(x => x === Role.Admin)) {
            return true;
        }
        return false;
    }

    //#region PrivateMethods

    // Checking if token is expired    
    private static isTokenExpired(token: TokenUser) {
        try {
            if (token.exp as number < Date.now() / 1000) {
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return false;
        }
    }

    // Saves user token to localStorage
    private static setToken(token: string) {
        localStorage.setItem(AuthService.TokenName, token);
        AuthService.setTokenSubjects();
    }

    // Sets new BehaviorSubject for currentUser    
    private static setTokenSubjects() {
        AuthService.currentUserSubject.next(AuthService.decodeToken());
    }

    // Retrieves the user token from localStorage
    static getToken() {
        return localStorage.getItem(AuthService.TokenName);
    }

    // Getting token from localstorage and decode using jwt-decode npm package
    private static decodeToken() {
        const token = AuthService.getToken();
        if (token) {
            const tokenUser = decode(token) as TokenUser;
            if (tokenUser && tokenUser.role) {
                tokenUser.roles = tokenUser.role.split(',');
            }
            return tokenUser;
        }
    }

    //#endregion
}